<template>
  <section class="contact--block bt-lightgray mb30-md mb20">
    <div
      class="form-group contact--details d-flex align-items-center justify-content-between py10 px20 mb0 bb-lightgray"
    >
      <div>
        <span class="mb10 fs14">
          Contact Information
        </span>
        <p class="mb0">
          Name: {{ fullName || "N\A" }}
          <br />
          Email: {{ email || "N\A" }}
          <br />
          Mobile Number: {{ contactNumber || "N\A" }}
        </p>
      </div>
      <div class="text-right">
        <template v-if="$store.state.checkout.isAuthUser">
          Not you?
          <a href="/logout" class="main-link">
            Logout
          </a>
        </template>
        <router-link v-else :to="{ name: 'information' }" class="main-link">
          Change
        </router-link>
      </div>
    </div>
    <div
      v-if="deliveryMethod === 'pickup'"
      class="form-group contact--details d-flex align-items-center justify-content-between py10 px20 mb0 bb-lightgray"
    >
      <div>
        <span class="mb10 fs14">
          Pickup at
        </span>
        <p class="mb0">
          {{ pickupLocationAddress }}
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'information' }" class="main-link">
          Change
        </router-link>
      </div>
    </div>
    <div
      v-else-if="deliveryMethod === 'shipping'"
      class="form-group contact--details d-flex align-items-center justify-content-between py10 px20 mb0 bb-lightgray"
    >
      <div>
        <span class="mb10 fs14">
          Ship to
        </span>
        <p class="mb0">
          {{ shippingAddress }}
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'information' }" class="main-link">
          Change
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    fullName() {
      return this.$store.state.checkout.contact.fullName;
    },
    email() {
      return this.$store.state.checkout.contact.email;
    },
    contactNumber() {
      return this.$store.state.checkout.contact.contactNumber;
    },
    deliveryMethod() {
      return this.$store.state.checkout.deliveryMethod;
    },
    shippingAddress() {
      return this.$store.getters["checkout/fullShippingAddress"];
    },
    pickupLocationAddress() {
      return this.$store.state.checkout.pickupLocationAddress;
    }
  }
};
</script>

<style></style>
